import clsx from 'clsx';
import React from 'react';
import { withGTM } from '../HOCs';
import { MuiAlert, MuiPortal, MuiSnackbar } from '../material-ui';
import RichText from '../RichText';
import { onDatalayer } from './MessageBar.datalayer';
import { MessageBarProps } from './MessageBar.interface';
import useStyles from './MessageBar.styles';

const MessageBar = ({
  message,
  onClose,
  isOpen,
  autoHideDuration,
  severity,
  hasOverlay = false,
}: MessageBarProps) => {
  const classes = useStyles();

  const RichTextGTM = withGTM({
    Component: RichText,
    onDatalayer,
  });

  return (
    <MuiPortal>
      {isOpen && hasOverlay && <div className={classes.overlay} />}
      <MuiSnackbar
        open={isOpen}
        autoHideDuration={autoHideDuration}
        onClose={onClose}
        className={clsx(classes.root, hasOverlay && classes.rootCentered)}
      >
        <MuiAlert onClose={onClose} severity={severity}>
          <RichTextGTM className={classes.message} content={message} />
        </MuiAlert>
      </MuiSnackbar>
    </MuiPortal>
  );
};

export default React.memo(MessageBar);
